// Import react lib
import { useState } from 'react';

// Import services
import {
    login as databaseLogin,
    logout as databaseLogout,
} from '../services/auth';

// Hook to login to the database
export function useLogin() {
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Create a login function
    async function login(email, password) {
        setIsLoading(true);
        setIsError(false);

        try {
            // Try to connect to the database
            await databaseLogin(email, password);
            return true;
        } catch (err) {
            setIsError(true);
            return false;
        } finally {
            setIsLoading(false);
        }
    }

    return { login, isLoading, isError };
}

// Hook to logout from database
export function useLogout() {
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Create a logout function
    async function logout() {
        setIsLoading(true);
        setIsError(false);

        try {
            // Try to logout from the database
            await databaseLogout();
            return true;
        } catch (err) {
            setIsError(true);
            return false;
        } finally {
            setIsLoading(false);
        }
    }

    return { logout, isLoading, isError };
}
